import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import {
  addUpdateDocumentTypeData,
  getDocumentTypeById,
} from "../../../../thunks/documents";
import { VALIDATION_MSG } from "../../../../utils/constant";

const AddUpdateDocumentType = ({
  open,
  handleClose,
  selectedData,
  getDocumentTypesData,
  subTypes,
}) => {
  const dispatch = useDispatch();
  const [documentType, setDocumentType] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [isError, setIsError] = useState(false);
  const [selectedSubType, setSelectedSubType] = useState([]);
  const lookups = useSelector((state) => state?.lookupData);
  const [isLoader, setLoader] = useState(false);
  const [isApplicable, SetIsApplicable] = useState("");
  let { "Document Type": documentTypeId, "Template Type": templateType } =
    lookups || {};

  const handleChangeSubTypes = (value) => {
    if (value) {
      setSelectedSubType(value);
    } else {
      selectedSubType([]);
    }
  };
  const handleClickCreate = async () => {
    const tempSubType = [];
    if (selectedSubType?.length > 0) {
      selectedSubType?.map((d) => {
        tempSubType.push({
          id: d?.id,
          name: d?.name,
        });
      });
    }
    const lookupViews = [];
    if (isApplicable?.includes("Client")) {
      lookupViews.push({ viewOn: "Client" });
    }
    if (isApplicable?.includes("Case")) {
      lookupViews.push({ viewOn: "Case" });
    }
    if (isApplicable?.includes("Both")) {
      lookupViews.push({ viewOn: "Client" }, { viewOn: "Case" });
    }
    if (!documentType || !isApplicable) {
      setIsError(true);
      return;
    }
    const payload = {
      id: selectedData ? selectedData?.id : documentTypeId[0]?.lookuptypeid,
      name: documentType,
      subLookups: tempSubType || [],
      isActive: isActive,
      isUpdate: selectedData ? true : false,
      lookupViews: lookupViews,
    };
    try {
      setLoader(true);
      const response = await dispatch(
        addUpdateDocumentTypeData(payload)
      ).unwrap();
      if (response) {
        handleClose();
        setLoader(false);
        getDocumentTypesData();
        dispatch(
          showSnackbar({
            message: "Document type created successfully",
            severity: "success",
          })
        );
      } else {
        handleClose();
        setLoader(false);
      }
    } catch (error) {
      handleClose();
      setLoader(false);
      dispatch(
        showSnackbar({
          message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };

  // Method to get document type details by passing ID
  const getDocumentTypeDetails = async () => {
    try {
      const response = await dispatch(
        getDocumentTypeById(selectedData?.id)
      ).unwrap();
      if (response) {
        setDocumentType(response?.name);
        setSelectedSubType(response?.SubLookup || []);
        setIsActive(response?.isActive);
      }
    } catch (error) {
      return error;
    }
  };
  useEffect(() => {
    if (selectedData) {
      getDocumentTypeDetails();
    } else {
      setDocumentType(null);
      setSelectedSubType([]);
    }
  }, [selectedData]);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{ sx: { borderRadius: "28px", paddingBottom: 0 } }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* Loader Component */}
        {isLoader && <Loader />}
        <DialogContent>
          <Grid container spacing={3}>
            {/* Create Task Label Section */}
            <Grid item xs={12}>
              <Typography
                className="serif_display_regular_26 green"
                textAlign={"center"}
              >
                Document Type
              </Typography>
            </Grid>

            {/* Task Name Field Section */}
            <Grid item xs={12}>
              <TextField
                className="inputTextField normal_normal_600_12_Manropee"
                label="Document Type"
                placeholder="Document Type"
                fullWidth
                required
                size="small"
                value={documentType || null}
                onChange={(e) => setDocumentType(e?.target?.value)}
                error={isError && !documentType}
                helperText={isError && !documentType && VALIDATION_MSG.REQUIRED}
                InputLabelProps={{ shrink: true }}
                variant="standard"
              />
            </Grid>

            {/* Add/Update subTypes */}
            <Grid item xs={12}>
              <Autocomplete
                multiple
                value={selectedSubType || []}
                id="tags-outlined"
                options={subTypes || []}
                getOptionLabel={(option) => option?.name}
                onChange={(event, value) => handleChangeSubTypes(value)}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    className="normal_normal_600_12_Manropee"
                    size="small"
                    label={
                      <Typography sx={{ color: "#01ce3f" }}>
                        Sub Types
                      </Typography>
                    }
                    placeholder="Select Sub Types"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   style: {
                    //     maxHeight: "700px",
                    //     display: "flex",
                    //     flexDirection: "column",
                    //     flexWrap: "wrap",
                    //     overflowY: "auto",
                    //     marginTop: 10,
                    //     alignItems: "flex-start",
                    //   },
                    // }}
                  />
                )}
              />
            </Grid>

            {/* Is Active & Type dropdown section */}
            <Grid
              container
              xs={12}
              spacing={3}
              m={2}
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {/* Is Active */}
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "#00CE3F",
                        "&.Mui-checked": {
                          color: "#00CE3F",
                        },
                      }}
                      checked={isActive || false}
                      onChange={(e) => setIsActive(e?.target?.checked)}
                    />
                  }
                  label="Is Active?"
                />
              </Grid>
              {/* Applicable to both/not */}
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel
                    shrink={true}
                    className="normal_normal_600_12_Manropee"
                    style={{
                      lineHeight: "2.0375",
                      marginLeft: "-12px",
                      color: "#01ce3f",
                    }}
                    required
                  >
                    Applicable to
                  </InputLabel>
                  <Select
                    className="formControlField"
                    variant="standard"
                    size="small"
                    name="templatetype"
                    value={isApplicable || ""}
                    onChange={(event) => SetIsApplicable(event?.target?.value)}
                    fullWidth
                  >
                    {templateType?.map((d) => (
                      <MenuItem
                        className="normal_normal_18_Manrope dark_grey"
                        value={d?.value}
                        key={d?.id}
                      >
                        {d?.label}
                      </MenuItem>
                    ))}
                    <MenuItem
                      className="normal_normal_18_Manrope dark_grey"
                      value={"Both"}
                    >
                      Applicable to both
                    </MenuItem>
                  </Select>
                  {isError && !isApplicable && (
                    <FormHelperText className="red">
                      {VALIDATION_MSG.REQUIRED}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            {/* Submit Button */}
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button className="save_button" onClick={handleClickCreate}>
                {selectedData ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddUpdateDocumentType;
